import { apiGet } from 'tennders-stracture/libs/api'
import { useCallback, useState } from 'react'
import { addLoadFormStorageKey } from 'tennders-common/constants/useConstants'
import AppStorage from 'tennders-stracture/libs/storage'
import { useRouter } from 'next/router'

const useLoadDuplicate = () => {
  const [loading, setLoading] = useState(false)
  const router = useRouter()

  const loadDuplicate = useCallback(async (id) => {
    setLoading(true)
    const data = await apiGet('/templates/copy/' + id)
    const content = data.content
    const tab = content.toQuote ? 'to-quote' : 'confirmed'
    router.push('/add/load?ltab=' + tab + '&loadDraft=true')

    const key = addLoadFormStorageKey + '_' + tab
    AppStorage.saveToSessionStorage(key, content)

    setLoading(false)
    return data
  }, [])

  return { loading, loadDuplicate }
}

export default useLoadDuplicate
